import Button from './Button/Button.vue'
import Modal from './Modal/Modal.vue'
import Field from './field/field.vue'
import Progress from './progress/progress.vue'
import Box from './box/box.vue'
import MonthChecker from './monthChecker/monthChecker.vue'
import Slider from './slider/slider.vue'
import Address from './address/address.vue'


export {
  Button,
  Modal,
  Field,
  Progress,
  Box,
  MonthChecker,
  Slider,
  Address
}



// WEBPACK FOOTER //
// ./src/components/index.js